const filters = {
  btnFilters: 'Filtros',
  titleDropdown: 'Filtros rápidos',

  filterDate: {
    today: 'Hoy',
    tomorrow: 'Mañana',
    yesterday: 'Ayer',
    lastWeek: 'Semana Pasada',
    lastMonth: 'Último mes',
    customRange: 'Intervalo personalizado',
    overLimit: 'Por favor, selecciona un período de {{limit}} días o menos',
    fromTime: 'Desde el tiempo',
    toTime: 'Al tiempo',
  },
};

export default filters;
